import React, { cloneElement, useEffect } from 'react';
import cx from 'classnames';
import Clickable from '@move-ui/clickable';
import { Chip } from '../internals/Chip';
import styles from './CardChip.module.css';
export const CardChip = ({ id, name, className, children, onClick, onLabelClick, isSet, disabled, optionType, inputRef, value, hideOutline, icon }) => {
    useEffect(() => {
        import('focus-visible').catch(() => null);
    }, []);
    return (React.createElement(Chip, { id: id, name: name, className: cx(className, styles.component, {
            [styles.disabled]: disabled
        }), inputClassName: styles.input, onClick: onClick, onLabelClick: onLabelClick, isSet: isSet, isSetClassName: styles.isSet, disabled: disabled, optionType: optionType, inputRef: inputRef, value: value, hideOutline: hideOutline },
        icon && (React.createElement(Clickable, { className: styles.iconButton, tabIndex: -1 }, cloneElement(icon, { className: styles.icon }))),
        children));
};
//# sourceMappingURL=CardChip.js.map